import { DatePipe, CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {
  Component,
  Input,
  SimpleChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import { AppsService } from "src/app/shared/services/apps.service";
import moment from "moment";
import { Router } from "@angular/router";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { NzIconModule } from "ng-zorro-antd/icon";
import { SharedModule } from "src/app/shared/shared.module";

@Component({
  selector: "app-veh-widget",
  imports: [CommonModule, NzIconModule, SharedModule],
  templateUrl: "./veh-widget.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./veh-widget.component.scss",
})
export class VehWidgetComponent {
  @Input() vehicle: any;
  @Input() playbackDate?: string; // Date from playback filters (YYYY-MM-DD format)
  @Input() playbackVehicleId?: any; // Vehicle ID from playback filters
  slctdDt = new Date();
  currentDate;
  currentFrmtDate;
  currentTimeStmp;
  clntDtls;
  userDtls;
  curYr;
  today = new Date();
  vehnm;
  asrt_sts_nm;
  ctgrynm;
  grpnm;
  vehOdmtr;
  devOdmtr;
  imei;
  chasis;
  data_lst_rcvd;
  speed;
  dst_tvl_tdy;
  CrntDyDst;
  selectedtenant;
  selectedVehicle;
  vehId;
  VhcleDetails: any = {};
  diffTimeInMin;
  diffTimeInHrs;
  diffTimeInDys;
  recievedTime;
  showLdr = false;
  vstdLctns: any;
  ovrSpeed: any;
  oprtnlhrs: any;
  tripsData: any[];
  eachVeh: any;
  previousNotifications: any;
  vehRts: any = [];
  oprtdNtoprtd: any;
  vstdLctnsMsg: string;
  ovrSpeedMsg: string;
  oprtnlhrsMsg: string;
  tripsMsg: string;
  previousNotificationsMsg: string;
  shwStpgWndw = false;
  stpgData = [];
  stpgcolumnDefs = [];
  curDate: string;
  errMsg: string;
  chart1Msg: string;
  expandedSections: { [key: string]: boolean } = {
    trips: false,
    operational: false,
    speedViolation: false,
    tripsList: false,
    notifications: false,
    visitedLocations: false,
  };
  vehicleCardExpanded = false; // Track vehicle card expansion state
  currentTripStatus: any = null; // Store current trip running status
  allTripsData: any[] = []; // Store all trips data
  loadingCurrentTrip = false; // Loading state for current trip
  showTripDetails = false; // Toggle to show/hide other trips
  allTripsCompleted = false; // Flag to check if all trips are completed

  constructor(
    public apiServ: AppsService,
    private http: HttpClient,
    public datepipe: DatePipe,
    public TransfereService: TransfereService,
    public router: Router
  ) {
    this.slctdDt = new Date();
    console.log(this.slctdDt);
    this.currentDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.currentFrmtDate = moment(this.slctdDt).format("DD-MM-YYYY");
    this.currentTimeStmp = moment(this.slctdDt).format("DD-MM-YYYY HH:mm:ss");
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    console.log(this.userDtls);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.vehicle && changes.vehicle.currentValue) {
      const newVehicleId = changes.vehicle.currentValue.asrt_id;
      // Only fetch data if vehicle ID actually changed (prevents refresh on same vehicle)
      if (!this.vehId || this.vehId !== newVehicleId) {
        console.log(
          "Vehicle changed, fetching details:",
          changes.vehicle.currentValue
        );
        this.curYr = moment(this.today).format("YYYY");
        this.vehnm = changes.vehicle.currentValue.asrt_nm;
        this.vehId = newVehicleId; // Store current vehicle ID
        this.getVehicleDtls(newVehicleId);
        this.getPreviousNotifications(newVehicleId);
        // Check if we should fetch trip status (only if playback vehicle/date changed)
        this.checkAndFetchTripStatus();
      } else {
        // Vehicle ID hasn't changed - skip API call (data refresh prevention)
        console.log("Vehicle ID unchanged, skipping API call:", newVehicleId);
      }
    }

    // Check if playback date or vehicle ID changed
    if (changes.playbackDate || changes.playbackVehicleId) {
      this.checkAndFetchTripStatus();
    }
  }

  checkAndFetchTripStatus() {
    // Only fetch trip status if we have a playback vehicle ID or if vehicle is selected
    const vehicleId =
      this.playbackVehicleId || this.vehId || this.vehicle?.asrt_id;
    if (vehicleId) {
      this.getCurrentTripStatus();
    }
  }
  getVehicleDtls(asrt_id) {
    this.VhcleDetails = {};
    this.apiServ
      .get(`drivers/vehicles/vehicleById/${asrt_id}`)
      .subscribe((res) => {
        if (res["status"] == 200) {
          // var res_data = res['data'];
          // if (res_data) {
          this.VhcleDetails = res["data"][0];
          console.log(this.VhcleDetails);
          // }
          this.vehnm = this.VhcleDetails.asrt_nm;
          this.asrt_sts_nm = this.VhcleDetails.asrt_sts_nm;
          this.ctgrynm = this.VhcleDetails.asrt_ctgry_nm;
          this.grpnm = this.VhcleDetails.asrt_grp_nm;
          this.vehOdmtr = this.VhcleDetails.veh_odmtr_ct;
          this.devOdmtr = this.VhcleDetails.dvce_odmtr_ct;
          this.imei = this.VhcleDetails.dev_imei_nu;
          this.chasis = this.VhcleDetails.asrt_chses_nu;
          this.data_lst_rcvd = this.VhcleDetails.data_received_ts;
          this.currentTimeStmp = moment(this.slctdDt).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.recievedTime = moment(this.data_lst_rcvd).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          // console.log(this.recievedTime)
          // console.log( this.currentTimeStmp)
          this.diffTimeInMin = moment(this.currentTimeStmp).diff(
            this.recievedTime,
            "minute"
          );
          this.diffTimeInHrs = moment(this.currentTimeStmp).diff(
            this.recievedTime,
            "hours"
          );
          this.diffTimeInDys = moment(this.currentTimeStmp).diff(
            this.recievedTime,
            "days"
          );
          // console.log(this.diffTimeInMin)
          // console.log(this.diffTimeInHrs)
          // console.log(this.diffTimeInDys)

          this.speed = this.VhcleDetails.speed_ct;
          this.dst_tvl_tdy = this.VhcleDetails.tdy_dst;
          this.CrntDyDst = this.VhcleDetails.trp_dst;
          this.selectedtenant = this.VhcleDetails.tnt_id;
          //   }
          // }
          console.log(
            this.vehnm,
            this.asrt_sts_nm,
            this.ctgrynm,
            this.grpnm,
            this.VhcleDetails.stps_morethn_five
          );
          // Check if we should fetch trip status (only if playback vehicle/date changed)
          this.checkAndFetchTripStatus();
          if (this.VhcleDetails.asrt_sts_nm) {
            this.asrt_sts_nm = this.VhcleDetails.asrt_sts_nm;
          } else if (this.VhcleDetails.trp_status) {
            this.asrt_sts_nm = this.VhcleDetails.trp_status;
          } else {
            this.asrt_sts_nm = "";
          }
          this.ctgrynm = this.VhcleDetails.asrt_ctgry_nm;
          this.grpnm = this.VhcleDetails.asrt_grp_nm;
          this.selectedVehicle = this.VhcleDetails.asrt_id;
          this.vehId = this.VhcleDetails.asrt_id;
          console.log(this.VhcleDetails);
          // Don't call APIs automatically - only when accordion sections are expanded
          // this.get_allCtgrysData(this.vehId);
          // this.getVstdLctns(this.vehId);
          // this.getVhcleTrgts(this.vehId);
          // this.getTripsData();
        }
      });
  }
  getVstdLctns(veh_id) {
    this.apiServ
      .get(`dashboard/enterprise/echVehicleLocations/${veh_id}`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data) {
              this.vstdLctns = res["data"];
              console.log(this.vstdLctns.length);
              if (this.vstdLctns.length == 0) {
                this.vstdLctnsMsg =
                  "Visited locations not found to this vehicle.";
              } else {
                this.vstdLctnsMsg = "";
              }
            }
            this.showLdr = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }
  getVhcleTrgts(veh_id) {
    // This method is kept for backward compatibility but data loading is now handled by toggleSection
    // Charts are created when tripsList section is expanded
  }

  getPreviousNotifications(veh_id) {
    this.showLdr = true;
    this.previousNotifications = [];
    const rte = `dashboard/enterprise/last_10VehNtfcntsLst/${veh_id}`;
    this.apiServ.get(rte).subscribe(
      (res) => {
        this.showLdr = false;
        if (res["status"] == 200) {
          let data = res["data"];
          this.previousNotifications = data;
        }
        if (this.previousNotifications == 0) {
          this.previousNotificationsMsg =
            "Notifications not found to this vehicle.";
        } else {
          this.previousNotificationsMsg = "";
        }
      },
      (error) => {
        this.showLdr = false;
      }
    );
  }

  getCurrentTripStatus() {
    if (!this.VhcleDetails.asrt_id) {
      return;
    }
    this.loadingCurrentTrip = true;
    this.currentTripStatus = null;
    this.allTripsData = [];
    this.showTripDetails = false;
    this.allTripsCompleted = false;

    // Use playback date if available, otherwise use current date
    const tripDate = moment(new Date()).format("YYYY-MM-DD");

    // Use the same API endpoint as ward-trip-cvrge-dashboard
    const postData = {
      dt: tripDate,
      slctd_tnt: this.selectedtenant || this.VhcleDetails?.tnt_id,
      asrt_id: this.VhcleDetails.asrt_id,
    };

    const route = `dashboard/enterprise/wards/vehicles/getCoveredTripsDetails`;
    console.log(postData);
    this.apiServ.post(postData, route).subscribe(
      (res) => {
        this.loadingCurrentTrip = false;
        if (
          res &&
          res["status"] == 200 &&
          res["data"] &&
          res["data"].length > 0
        ) {
          this.allTripsData = res["data"];
          console.log(this.allTripsData);

          // Find the running/active trip (status = 'Running' or 'In Progress')
          const runningTrip = this.allTripsData.find(
            (trip: any) =>
              trip.TripStatus === "Running" ||
              trip.TripStatus === "In Progress" ||
              trip.trp_status === "Running" ||
              trip.trp_status === "In Progress"
          );

          // Check if all trips are completed
          const allCompleted = this.allTripsData.every(
            (trip: any) =>
              trip.TripStatus === "Completed" ||
              trip.trp_status === "Completed" ||
              trip.ACTUAL_END // Has end time means completed
          );

          this.allTripsCompleted = allCompleted;

          // If running trip found, show it first
          if (runningTrip) {
            this.currentTripStatus = runningTrip;
          } else if (this.allTripsData.length > 0) {
            // If all completed, show the first trip (most recent)
            this.currentTripStatus = this.allTripsData[0];
          }
        }
      },
      (err) => {
        this.loadingCurrentTrip = false;
        console.error("Error fetching current trip status:", err);
      }
    );
  }

  toggleTripDetails() {
    this.showTripDetails = !this.showTripDetails;
  }

  getTripsData() {
    if (this.tripsData && this.tripsData.length > 0) {
      return; // Already loaded
    }
    this.tripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
      asrt_id: this.selectedVehicle,
    };
    let rte = `dashboard/enterprise/wards/vehicles/getCoveredTripsDetails`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tripsData = res["data"];
        }
        this.showLdr = false;
      },
      (err) => {
        this.showLdr = false;
      }
    );
  }

  toggleSection(section: string) {
    // If opening a section, close all other sections (accordion behavior)
    if (!this.expandedSections[section]) {
      // Close all other sections
      Object.keys(this.expandedSections).forEach((key) => {
        if (key !== section) {
          this.expandedSections[key] = false;
        }
      });
    }

    this.expandedSections[section] = !this.expandedSections[section];

    // Load data when section is expanded
    if (this.expandedSections[section]) {
      switch (section) {
        case "trips":
          if (!this.tripsData || this.tripsData.length === 0) {
            this.getTripsData();
          }
          break;
        case "operational":
          if (!this.oprtnlhrs || this.oprtnlhrs.length === 0) {
            this.getOperationalData(this.vehId);
          }
          break;
        case "speedViolation":
          if (!this.ovrSpeed || this.ovrSpeed.length === 0) {
            this.getSpeedViolationData(this.vehId);
          }
          break;
        case "tripsList":
          if (!this.eachVeh || this.eachVeh.length === 0) {
            this.getVehicleTargetsData(this.vehId);
          }
          break;
        case "notifications":
          if (
            !this.previousNotifications ||
            this.previousNotifications.length === 0
          ) {
            this.getPreviousNotifications(this.vehId);
          }
          break;
        case "visitedLocations":
          if (!this.vstdLctns || this.vstdLctns.length === 0) {
            this.getVstdLctns(this.vehId);
          }
          break;
      }
    }
  }

  toggleVehicleCard() {
    this.vehicleCardExpanded = !this.vehicleCardExpanded;
  }

  getOperationalData(veh_id) {
    this.oprtnlhrs = [];
    this.showLdr = true;
    this.apiServ.get(`dashboard/enterprise/operational/${veh_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data) {
            const allData = res["data"];
            // Filter to show only current day data
            const currentDate = moment(this.slctdDt).format("DD-MM-YYYY");
            this.oprtnlhrs = allData.filter((item) => {
              // Handle different date formats from API
              let itemDate = "";
              if (item.dt) {
                // Try parsing the date in various formats
                const parsedDate = moment(item.dt);
                if (parsedDate.isValid()) {
                  itemDate = parsedDate.format("DD-MM-YYYY");
                } else {
                  // If dt is already in DD-MM-YYYY format
                  itemDate = item.dt;
                }
              }
              return itemDate === currentDate;
            });
            if (this.oprtnlhrs.length == 0) {
              this.oprtnlhrsMsg = "No Operational Details found for today.";
            } else {
              this.oprtnlhrsMsg = "";
            }
          }
          this.showLdr = false;
        }
      },
      (err) => {
        this.showLdr = false;
      }
    );
  }

  getSpeedViolationData(veh_id) {
    this.ovrSpeed = [];
    this.showLdr = true;
    this.apiServ
      .get(`dashboard/enterprise/echVehicleOvrSpeed/${veh_id}`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data) {
              this.ovrSpeed = res["data"];
              if (this.ovrSpeed.length == 0) {
                this.ovrSpeedMsg = "Speed Violation not found to this vehicle.";
              } else {
                this.ovrSpeedMsg = "";
              }
            }
            this.showLdr = false;
          }
        },
        (err) => {
          this.showLdr = false;
        }
      );
  }

  getVehicleTargetsData(veh_id) {
    let chart1 = am4core.create(
      "lastSevenDaysDistanceChart",
      am4charts.XYChart
    );
    let chart2 = am4core.create("lastSevenDaysChart", am4charts.XYChart);
    chart1.data = [];
    chart2.data = [];
    this.showLdr = true;
    this.apiServ.get(`dashboard/enterprise/vehicleTargets/${veh_id}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          console.log(res["data"]);
          chart1.data = res["data"]["results"];
          if (res["data"].msg == 0) {
            this.chart1Msg = "Last 7Days Distance not found to this vehicle.";
          } else {
            this.chart1Msg = "";
          }
          console.log(chart1.data);
          // Create axes
          let categoryAxis1 = chart1.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis1.dataFields.category = "dt";
          categoryAxis1.renderer.grid.template.location = 0.5;
          categoryAxis1.renderer.minGridDistance = 25;
          categoryAxis1.renderer.labels.template.rotation = 0;
          categoryAxis1.renderer.labels.template.horizontalCenter = "middle";
          categoryAxis1.renderer.labels.template.verticalCenter = "top";
          categoryAxis1.renderer.labels.template.dy = 8;
          categoryAxis1.renderer.labels.template.fontSize = 11;
          categoryAxis1.title.text = ` ----- Date(${this.curYr}) ----- `;

          let valueAxis1 = chart1.yAxes.push(new am4charts.ValueAxis());
          valueAxis1.title.text = " ----- Distance Covered -----";
          valueAxis1.cursorTooltipEnabled = false;

          // Create series
          let series1 = chart1.series.push(new am4charts.ColumnSeries());
          series1.dataFields.valueY = "mn_dst_ct";
          series1.dataFields.categoryX = "dt";
          series1.clustered = false;
          series1.tooltipText =
            "Total Distance in {categoryX}: [bold]{valueY}[/]";
          series1.columns.template.fill = am4core.color("#a9dcf4");
          series1.columns.template.stroke = am4core.color("#a9dcf4");

          let series2 = chart1.series.push(new am4charts.ColumnSeries());
          series2.dataFields.valueY = "trp_dst";
          series2.dataFields.categoryX = "dt";
          series2.clustered = false;
          series2.columns.template.width = am4core.percent(50);
          series2.tooltipText =
            "Covered Distance in {categoryX}: [bold]{valueY}[/]";
          series2.columns.template.fill = am4core.color("#92c5dd");
          series2.columns.template.stroke = am4core.color("#92c5dd");
          let valueLabel = series2.bullets.push(new am4charts.LabelBullet());
          valueLabel.label.text = "{trp_dst}";
          valueLabel.label.fontSize = 12;
          let columnTemplate1 = series2.columns.template;
          columnTemplate1.strokeWidth = 1;

          chart1.cursor = new am4charts.XYCursor();
          chart1.cursor.lineX.disabled = true;
          chart1.cursor.lineY.disabled = true;

          for (let j = 0; j <= chart1.data.length - 1; j++) {
            if (chart1.data[j].dt == this.currentFrmtDate) {
              this.CrntDyDst = chart1.data[j].trp_dst;
            }
          }
          // }
          this.eachVeh = [];
          if (res["data"]) {
            chart2.data = res["data"]["results"];
            this.eachVeh = chart2.data;
            if (res["data"].msg == 0) {
              this.tripsMsg = "Last 7Days Trips not found to this vehicle.";
            } else {
              this.tripsMsg = "";
            }
            // Create axes
            let categoryAxis = chart2.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "dt";
            categoryAxis.renderer.grid.template.location = 0.5;
            categoryAxis.renderer.minGridDistance = 25;
            categoryAxis.renderer.labels.template.rotation = 0;
            categoryAxis.renderer.labels.template.horizontalCenter = "middle";
            categoryAxis.renderer.labels.template.verticalCenter = "top";
            categoryAxis.renderer.labels.template.dy = 8;
            categoryAxis.renderer.labels.template.fontSize = 11;
            categoryAxis.title.text = ` ----- Date(${this.curYr}) ----- `;

            let valueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = " ----- Trip Count -----";
            valueAxis.cursorTooltipEnabled = false;

            // Create series
            let series3 = chart2.series.push(new am4charts.ColumnSeries());
            series3.dataFields.valueY = "mn_trp_ct";
            series3.dataFields.categoryX = "dt";
            series3.clustered = false;
            series3.tooltipText =
              "Targeted Trips in {categoryX}: [bold]{valueY}[/]";
            series3.columns.template.fill = am4core.color("#f4a9be");
            series3.columns.template.stroke = am4core.color("#f4a9be");

            let series4 = chart2.series.push(new am4charts.ColumnSeries());
            series4.dataFields.valueY = "trp_cnt";
            series4.dataFields.categoryX = "dt";
            series4.clustered = false;
            series4.columns.template.width = am4core.percent(50);
            series4.tooltipText =
              "Travelled Trips in {categoryX}: [bold]{valueY}[/]";
            series4.columns.template.fill = am4core.color("#dd92a7");
            series4.columns.template.stroke = am4core.color("#dd92a7");

            let valueLabel2 = series4.bullets.push(new am4charts.LabelBullet());
            valueLabel2.label.text = "{trp_cnt}";
            valueLabel2.label.fontSize = 12;
            let columnTemplate2 = series4.columns.template;
            columnTemplate2.strokeWidth = 1;

            chart2.cursor = new am4charts.XYCursor();
            chart2.cursor.lineX.disabled = true;
            chart2.cursor.lineY.disabled = true;
          }
          if (res["data"] == undefined) {
            this.errMsg = `Last 7Days Trips not found to this vehicle.`;
          } else {
            this.errMsg = ``;
          }
          this.showLdr = false;
        }
      },
      (err) => {
        this.showLdr = false;
      }
    );
  }

  showStoppages() {
    if (this.VhcleDetails.stps_morethn_five > 0) {
      this.shwStpgWndw = true;
      this.stpgData = [];
      this.apiServ
        .get(`dashboard/enterprise/vehicles/stops/${this.selectedVehicle}`)
        .subscribe((res) => {
          if (res["status"] == 200) {
            this.stpgData = res["data"];
            this.stpgcolumnDefs = [
              {
                field: "sno",
                headerName: "Sno",
                visible: true,
                width: 80,
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_nm",
                headerName: "Vehicle",
                visible: true,
                width: 150,
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_ctgry_nm",
                headerName: "Vehicle Category",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_stp_strt_ts",
                headerName: "Stopage start time",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "asrt_stp_end_ts",
                headerName: "Stopage end time",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "duration",
                headerName: "Stopage duration (Min)",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
              {
                field: "adrs_tx",
                headerName: "Address",
                visible: true,
                width: "auto",
                alignment: "center",
                filter: true,
              },
            ];
          }
        });
    }
  }

  closeStpgSideBar() {
    this.shwStpgWndw = false;
  }

  handleOk() {
    this.shwStpgWndw = false;
  }

  vewonMap(f) {
    console.log(f);
    var latitude = f.lat;
    var longitude = f.lng;
    var mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(mapUrl, "_blank");
  }

  goToPlayback(t) {
    console.log(t);
    let data = {
      asrt_id: t.asrt_id,
      asrt_nm: t.VEHICLE,
      trp_rn_id: t.TRIP_ID,
      trp_sqnc_nu: t.trp_sqnc_nu,
      actl_strt_ts: t.actl_strt_ts,
      actl_strt: t.actl_strt_ts,
      actl_end_ts: t.actl_end_ts,
      actl_end: t.actl_end_ts,
      tnt_id: t.tnt_id,
      clnt_id: t.clnt_id,
    };
    this.TransfereService.setLoclData("plybckDta", data);
    this.router.navigate([`internal/play-back/list`]);
  }

  showOnMap() {
    window.open(
      `https://www.google.com/maps?q=${this.VhcleDetails.lat},${this.VhcleDetails.lng}`,
      "_blank"
    );
  }
}
